import { ObservableModelNode } from "../observable";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class DecorationGeneratorModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    effect: { label: "Effect", fieldType: "text" },
    fabricName: { label: "Fabric name", fieldType: "text" },
    stitchFabricName: { label: "Stitch fabric name", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  effect!: string;
  fabricName!: string;
  stitchFabricName!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("effect", "");
    this.defineObservableValue("fabricName", "");
    this.defineObservableValue("stitchFabricName", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "decoration generator");
    this.effect = readString(source, "effect");
    this.fabricName = readString(source, "fabricName");
    this.stitchFabricName = readString(source, "stitchFabricName");
    this.extra = splitKnown(source, [
      "effect",
      "fabricName",
      "stitchFabricName",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.effect ? { effect: this.effect } : {}),
      ...(this.fabricName ? { fabricName: this.fabricName } : {}),
      ...(this.stitchFabricName
        ? { stitchFabricName: this.stitchFabricName }
        : {}),
    };
  }
}
